import { css } from 'styled-components'

import { OptionItem } from '@/components/option-list'

const style = css`
  border: none;
`

const DropdownItem = ({ children, ...rest }) => (
  <OptionItem {...rest} showSelect={false} customStyle={style}>
    {children}
  </OptionItem>
)

export default DropdownItem
